import { defineStore } from 'pinia'
import { useApi } from '@/composables/useApi'
import type { RolesType } from '@/plugins/casl/ability'

interface IUser {
  avatar: string
  nickname: string
  roles: RolesType[]
}

interface IUserState {
  userData: IUser | null
}

export const useUserStore = defineStore('user', {
  state: (): IUserState => ({
    userData: null,
  }),
  getters: {
    roles: state => state.userData && state.userData.roles.map(role => role.toLowerCase()),
  },
  actions: {
    async getUserData() {
      if (this.userData) {
        return Promise.resolve(this.userData)
      }

      return useApi<IUser>('/user', {
        method: 'GET',
      }).then(({ data }) => {
        if (data.value) {
          this.userData = data.value
        }

        return data.value
      }).catch((error) => {
        return Promise.reject(error)
      })
    },
  },
})
